export default import.meta.ROLLDOWN_FILE_URL_tbV5o7rgOmJgt7fUpi93jQ